import { ShippingError, type ShippingErrorValues } from '../../types/Shipping';
import { t } from '../../utils/i18n';

export interface ApplePayErrorConstructorParams {
  code: ApplePayJS.ApplePayErrorCode;
  contactField: ApplePayJS.ApplePayErrorContactField;
  message: string;
}

export const createApplePayError = (p: ApplePayErrorConstructorParams) => {
  return new window.ApplePayError(p.code, p.contactField, p.message);
};

export const createApplePayErrorConstructorParams = (
  error: ShippingErrorValues = ShippingError.SHIPPING_UNKNOWN,
): { code: ApplePayJS.ApplePayErrorCode; contactField: ApplePayJS.ApplePayErrorContactField; message: string } => {
  switch (error) {
    case ShippingError.SHIPPING_CONTACT_INVALID:
      return {
        code: 'shippingContactInvalid',
        contactField: undefined,
        message: t('pm.shipping.contactInvalid'),
      };

    case ShippingError.SHIPPING_ADDRESS_UNSERVICEABLE:
      return {
        code: 'addressUnserviceable',
        contactField: 'country',
        message: t('pm.shipping.contactAddressUnserviceable'),
      };

    case ShippingError.SHIPPING_UNKNOWN:
    default:
      return { code: 'unknown', contactField: undefined, message: t('pm.shipping.unknownError') };
  }
};
